<template>
  <div class="flex flex-col overflow-x-auto">
    <div class="overflow-x-auto">
      <div class="inline-block w-full py-2 align-middle">
        <h1
          class="py-2 text-lg font-medium text-ontick-steel-900 dark:text-gray-300"
        >
          Ordens
        </h1>

        <div
          class="overflow-hidden border-b border-ontick-steel-300 shadow dark:border-ontick-steel-600 sm:rounded-lg"
        >
          <table
            class="min-w-full divide-y divide-ontick-steel-300 dark:divide-ontick-steel-600"
          >
            <thead class="bg-ontick-steel-100 dark:bg-ontick-steel-600">
              <tr>
                <th
                  v-for="(item, index) in header"
                  :key="index"
                  scope="col"
                  class="title_th"
                >
                  <button
                    class="flex h-full w-full items-center justify-center space-x-1 text-center"
                    @click="sort(item.key)"
                  >
                    <span v-if="item.key === sortKey">
                      {{ sortIcon }}
                    </span>
                    <p>
                      {{ item.label }}
                    </p>
                  </button>
                </th>
              </tr>
            </thead>
            <transition-group
              v-on:enter="enter"
              v-on:leave="leave"
              v-bind:css="true"
              appear
              tag="tbody"
              class="divide-y divide-ontick-steel-300 dark:divide-ontick-steel-600"
            >
              <tr
                class="bg-gray-50 dark:bg-ontick-graphite-500"
                v-for="(item, index) in sortedData"
                :key="index"
              >
                <td class="td-items">
                  {{ item.order_symbol }}
                </td>
                <td class="td-items">
                  {{ item.strategy_name }}
                </td>
                <td class="td-items">
                  {{ item.order_time | moment("DD/MM/YYYY HH:mm:ss:SSS") }}
                </td>

                <td class="td-items">
                  <span
                    class="rounded px-2"
                    :class="statusBadge(item.order_state)"
                    :content="textTooltip(item.order_state)"
                    v-tippy="{ arrow: true, theme: 'green' }"
                  >
                    {{ item.order_state }}</span
                  >
                </td>

                <td class="td-items">
                  {{ item.order_goal }}
                </td>
                <td class="td-items">
                  {{ item.order_direction }}
                </td>

                <td class="td-items">
                  <span
                    class="rounded bg-ontick-prussian-400 px-2 text-ontick-prussian-50"
                  >
                    {{ item.order_type }}
                  </span>
                </td>

                <td class="td-items">
                  {{ item.order_volume }}
                </td>
                <td class="td-items">
                  {{ item.order_price }}
                </td>
                <td class="td-items">
                  {{ item.order_comment }}
                </td>
              </tr>
              <tr
                key="final"
                v-if="data.investments.length == 0 && !placeholder"
              >
                <td colspan="10">
                  <h2
                    class="py-20 text-center text-2xl font-medium text-ontick-steel-900 dark:text-gray-300"
                  >
                    Nenhuma orderm gerada
                  </h2>
                </td>
              </tr>

              <tr
                key="placeholder"
                v-if="data.investments.length == 0 && placeholder"
              >
                <td colspan="10">
                  <placeholder-card-component :qtd="3" />
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlaceholderCardComponent from "../../../../shared/components/placeholder/placeholder-card.component.vue";
export default {
  components: {
    PlaceholderCardComponent,
  },

  props: {
    data: {
      type: Object,
    },
    placeholder: {
      type: Boolean,
    },
  },

  data() {
    return {
      header: [
        { label: "Ativo", key: "order_symbol" },
        { label: "Estratégia", key: "strategy_name" },
        { label: "Horário", key: "order_time" },
        { label: "Status", key: "order_state" },
        { label: "Sentido", key: "order_goal" },
        { label: "Tipo", key: "order_direction" },
        { label: "Ordem", key: "order_type" },
        { label: "Volume", key: "order_volume" },
        { label: "Preço", key: "order_price" },
        { label: "Comentário", key: "order_comment" },
      ],
      sortDirection: "",
      sortKey: "",
    };
  },

  computed: {
    sortIcon() {
      const directions = {
        asc: "▲",
        desc: "▼",
      };
      return directions[this.sortDirection] || "";
    },
    presortedData() {
      return this.data.investments.sort((a, b) => {
        if (a.order_time > b.order_time) {
          return -1;
        } else if (a.order_time < b.order_time) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    sortedData() {
      switch (this.sortDirection) {
        case "asc":
          return this.presortedData.sort((a, b) => {
            if (a[this.sortKey] < b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] > b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        case "desc":
          return this.presortedData.sort((a, b) => {
            if (a[this.sortKey] > b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] < b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        default:
          return this.presortedData;
      }
    },
  },

  methods: {
    sort(key) {
      if (key) {
        if (this.sortKey === key) {
          this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
        } else {
          this.sortDirection = "asc";
        }
        this.sortKey = key;
      }
    },
    textTooltip(value) {
      let text = "";
      if (value == "C") {
        text = "Cancelada";
      } else if (value == "F") {
        text = "Executada";
      } else if (value == "R") {
        text = "Rejeitada";
      } else if (value == "T") {
        text = "Parcial";
      } else if (value == "E") {
        text = "Expirada";
      } else if (value == "Z") {
        text = "Congelada";
      } else if (value == "S") {
        text = "Iniciada";
      } else if (value == "P") {
        text = "Colocada ";
      }
      return text;
    },
    statusBadge(value) {
      let color = "";
      if (value == "P") {
        color = "bg-ontick-blue-800 text-ontick-blue-200";
      } else if (value == "F") {
        color = "bg-ontick-lime-900 text-ontick-lime-400";
      } else if (value == "S") {
        color = "bg-ontick-teal-600 text-ontick text-ontick-teal-50";
      } else if (value == "W") {
        color = "bg-gray-600 text-gray-300";
      } else if (value == "C") {
        color = "bg-ontick-orange-900 text-ontick-orange-300";
      } else if (value == "R") {
        color = "bg-ontick-red-900 text-ontick-red-300";
      } else if (value == "E") {
        color = "bg-ontick-pink-900 text-ontick-link-300";
      } else if (value == "T") {
        color = "bg-ontick-yellow-800 text-ontick-yellow-50";
      }
      return color;
    },

    enter(el, done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      tl.set(el, {
        x: window.innerWidth * 0.5,
        scale: 0.9,
        transformOrigin: "50% 50%",
      });

      tl.to(el, 0.3, {
        x: 0,
        ease: Power4.easeOut,
      });

      tl.to(el, 0.3, {
        scale: 1,
        ease: Power4.easeOut,
      });
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.3,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.title_th {
  @apply px-3 py-2 text-center text-sm font-medium text-ontick-steel-900 dark:text-gray-300;
}
.td-items {
  @apply whitespace-nowrap px-3 py-3 text-center text-xs text-ontick-steel-900 dark:text-gray-300;
}
</style>
